export default __webpack_public_path__ + "static/media/OrangeLogo.c581cf02.jpg";